var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66665 21.6608H3.33331C4.06834 21.6608 4.66665 21.0625 4.66665 20.3275V18.0208C4.66665 17.2858 4.06834 16.6875 3.33331 16.6875H1.66665C0.93162 16.6875 0.333313 17.2858 0.333313 18.0208V20.3275C0.333313 21.0625 0.93162 21.6608 1.66665 21.6608ZM1.66665 18.0208H3.33331L3.33462 20.3275H1.66665V18.0208Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 21.6595H9C9.73503 21.6595 10.3333 21.0612 10.3333 20.3262V12.0599C10.3333 11.3249 9.73503 10.7266 9 10.7266H7.33333C6.59831 10.7266 6 11.3249 6 12.0599V20.3262C6 21.0612 6.59831 21.6595 7.33333 21.6595ZM7.33333 12.0599H9L9.0013 20.3262H7.33333V12.0599Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.0469C12.2649 13.0469 11.6666 13.6452 11.6666 14.3802V20.3268C11.6666 21.0618 12.2649 21.6602 13 21.6602H14.6666C15.4017 21.6602 16 21.0618 16 20.3268V14.3802C16 13.6452 15.4017 13.0469 14.6666 13.0469H13ZM13 20.3268V14.3802H14.6666L14.6679 20.3268H13Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 20.3268V7.38021C21.6666 6.64518 21.0683 6.04688 20.3333 6.04688H18.6666C17.9316 6.04688 17.3333 6.64518 17.3333 7.38021V20.3268C17.3333 21.0618 17.9316 21.6602 18.6666 21.6602H20.3333C21.0683 21.6602 21.6666 21.0618 21.6666 20.3268ZM18.6666 7.38021H20.3333L20.3346 20.3268H18.6666V7.38021Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9648 10.1576L7.9954 5.12695C8.19332 4.92969 8.4967 4.875 8.75126 4.99544L12.722 6.86328C13.4811 7.22331 14.3925 7.0638 14.9876 6.4681L19.9785 1.47786C20.2389 1.21745 20.2389 0.795573 19.9785 0.535156C19.7181 0.27474 19.2962 0.27474 19.0358 0.535156L14.0449 5.52539C13.8463 5.72396 13.5423 5.77734 13.2897 5.6569L9.31897 3.78841C8.56051 3.43164 7.64775 3.58919 7.05269 4.18424L2.02209 9.21484C1.76168 9.47526 1.76168 9.89713 2.02209 10.1576C2.2825 10.418 2.70438 10.418 2.9648 10.1576Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/reportIcon.79679ae0f6ef07ce91287af4e1d4c495.svg";
export { ForwardRef as ReactComponent };